export const Lista_Niveles_Primeros_Auxilios = [
    'Ninguno',
    'Bajo (Primeros auxilios básicos)',
    'Bajo-Medio (WFA o primeros auxilios urbanos avanzados)',
    'Medio (WAFA o carreta técnica en salud)',
    'Medio-Alto (WFR o carrera profesional en salud)',
    'Alto (WFR y carrera relacionada con salud)',
] as const;